import "./Selector.css"

function SelectorPlots({props, onSelect, ResetConnectedButton, ResetMeansFlag, ResetNoRootFlag, ResetConnectedSelector, Reset}) {
    //console.log("Selector")
    
    
    const handleChange = (event) =>{
        onSelect(event.target.value);
        // if(ResetConnectedButton) {
        //     ResetConnectedButton(false);
        // }
        // if(ResetMeansFlag){
        //     ResetMeansFlag("");
        // }
        // if(ResetNoRootFlag) {
        //     ResetNoRootFlag(false);
        // }
        // if(ResetConnectedSelector) {

        //     ResetConnectedSelector("");
        // }
        if(Reset){
            Reset.ResetConnectedStartMeansValue("");
            Reset.ResetConnectedDestMeansValue("");
            Reset.ResetConnectedButton(false);
            Reset.ResetMeansFlag("");
            Reset.ResetNoRootFlag(false);
            Reset.ResetConnectedSelector("");
        }

    }
    return(
        <div id = "SelectorCustomClass">
            <p> <strong>{props.title}</strong> </p>
            <select defaultValue={'DEFAULT'}  aria-label=".form-select-lg example" onChange = {handleChange}>
                <option value="DEFAULT" disabled >{props.defaultText}</option>
                {props.options.map((option) => (
                    <option key={option.value} value={option.value}>
                    {option.label}
                    </option>
                ))}
            </select>
        </div>
      

    );
}

export default SelectorPlots;